import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

export interface EmailPreviewRequest {
  readonly templateKey: string;
  readonly model: Record<string, unknown>;
  readonly includeAnalytics?: boolean;
}

export interface EmailPreviewResponse {
  readonly htmlBody: string;
}

export interface EmailPreviewClient {
  getPreview(request: EmailPreviewRequest): Observable<EmailPreviewResponse>;
}

export const EMAIL_PREVIEW_CLIENT = new InjectionToken<EmailPreviewClient>(
  'EMAIL_PREVIEW_CLIENT'
);
